

import React, { memo } from 'react';
import RequestProvider from '../../../../RequestProvider';
import ConfirmationModalComponent from '../components/ConfirmationModal';
import { archiveAssetApi, unarchiveAssetApi } from '../api';










function ConfirmationModal({
  organisationName,
  visible,
  hideModal,
  assetId,
  confirmModalAction,
  onConfirmation
}) {
  return (
    <RequestProvider
      requests={{
        archiveAsset: archiveAssetApi(),
        unarchiveAsset: unarchiveAssetApi()
      }}>

      {({ archiveAsset, unarchiveAsset }) =>
      <ConfirmationModalComponent
        organisationName={organisationName}
        archiveAsset={archiveAsset}
        unarchiveAsset={unarchiveAsset}
        visible={visible}
        hideModal={hideModal}
        assetId={assetId}
        confirmModalAction={confirmModalAction}
        onConfirmation={onConfirmation} />}


    </RequestProvider>);

}

export default memo(ConfirmationModal);